import React from 'react';
import PieChart from 'components/@common/Charts/PieChart';
import { ApexOptions } from 'apexcharts';

type Props = {
  total: any;
  assigned: any;
  completed: any;
};

const SkillProgressChart: React.FC<Props> = ({ total, assigned, completed }) => {
  const options: ApexOptions = {
    tooltip: {
      enabled: true,
      y: {
        formatter: (data: any) => {
          return data; //value in tooltip
        },
        title: {
          formatter: (seriesName: any) => {
            return seriesName === 'Total' ? 'Remaining' : seriesName;
          }
        }
      }
    },
    legend: {
      show: false
    },
    stroke: {
      lineCap: 'round'
    },
    dataLabels: {
      enabled: false
    },
    plotOptions: {
      pie: {
        donut: {
          size: '80%',
          labels: {
            show: true,
            name: {
              show: true,
              offsetY: 30,
              fontSize: '24px',
              fontWeight: '400'
              // formatter: (val: any) => {
              //   return val + '%';
              // }
            },
            value: {
              show: true,
              offsetY: -10,
              fontWeight: 450,
              fontSize: '56px',
              formatter: (val: any) => {
                return val;
              }
            },
            total: {
              show: true,
              showAlways: true,
              fontSize: '16px',
              fontWeight: '400',
              formatter: () => {
                return completed;
              },
              label: 'Total Lessons Complete'
            }
          }
        }
      }
    },
    colors: ['#338AC6', '#338AC666', '#F4F4F4'],
    labels: ['Completed:', 'Assigned:', 'Remaining Total:']
  };

  const completedCount = completed;
  const assignedCount = assigned - completed;
  const totalCount = total - assigned;

  return (
    <PieChart
      type="donut"
      series={[completedCount, assignedCount, totalCount]}
      height={250}
      options={options}
    />
  );
};

export default SkillProgressChart;
